export const MAILSYSTEM_STATE_RUNNING = 'running';
export const MAILSYSTEM_STATE_PAUSED = 'paused';
export const MAILSYSTEM_STATE_AUTO_PAUSED = 'autopaused';

export const MAILSYSTEM_RUN_REGISTRATION = 'registration';
export const MAILSYSTEM_RUN_BOT = 'bot';
